import { toast } from 'react-toastify';
import haptic from '../../utils/haptics';

const MESSAGES = [
  'Great choice!',
  'Love that pick!',
  'You have excellent taste!',
  'This is going to be amazing!',
  'Perfect addition!',
  'Ooh, nice one!',
  'That sounds incredible!',
  'Bold move — we like it!',
];

let lastToastTime = 0;
const THROTTLE_MS = 8000;

/**
 * Show a throttled affirmation toast (max 1 per 8 seconds).
 * Call this on meaningful user interactions (slider changes, selections).
 */
export function showAffirmation() {
  const now = Date.now();
  if (now - lastToastTime < THROTTLE_MS) return;
  lastToastTime = now;

  const msg = MESSAGES[Math.floor(Math.random() * MESSAGES.length)];
  haptic.light();

  toast(msg, {
    position: 'bottom-center',
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    style: {
      background: 'rgba(30, 30, 50, 0.9)',
      backdropFilter: 'blur(12px)',
      color: 'white',
      borderRadius: '9999px',
      fontSize: '14px',
      fontWeight: 600,
      textAlign: 'center',
      padding: '10px 20px',
      minHeight: 'auto',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
    },
    bodyStyle: { padding: 0, margin: 0 },
  });
}

export default showAffirmation;
